export var ActivityBasedSchedulingRoutes = {
    "/forecasts-projections/:start_date": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-projects",
        "showGlobalSearch": true,
        "params": {start_date: ""},
        "type": "frontend",
        "views": {
            "body": {
                component: 'forecastsProjectionsComponent',
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import('../team-live/activity-based-scheduling-generation/activity-based-scheduling-generation.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["abs-generation"]
        },
        "onEnter": ['$state', 'TeamScheduleService', 'hUser', function ($state, TeamScheduleService, hUser) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    if (!TeamScheduleService.isABSServiceEnabled() || !hUser.hasSalesAccess()) {
                        $state.go("appLayout.schedule.main");
                    }
                });
        }]
    },
    "/forecasts-and-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-and-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: "forecastsAndLaborComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Forecasts"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "onEnter": ['$q', 'userServices', '$state', 'TeamScheduleService', 'hUser',
            function ($q, userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var promises = {};
                        promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brand.id);
                        promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id);

                        $q.all(promises)
                            .then(function (res) {
                                if ((!res.isABSServiceEnabled && !res.isDemandForecastingEnabled) || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/forecasts-templates/:start_date": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-templates",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: 'forecastsTemplatesContainer',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser', function (userServices, $state, TeamScheduleService, hUser) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var promises = {};
                    promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brand.id);
                    promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id);

                    $q.all(promises)
                        .then(function (res) {
                            if (!(res.isABSServiceEnabled && hUser.hasSalesAccess())) {
                                $state.go("appLayout.schedule.main");
                            }
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                });
        }]
    },
    "/forecast-rule/:rule_id?duplicate_id&step": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecast-settings-rule",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: 'manageAbsForecastRuleContainer',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: [
                'abs-settings',
            ],
        },
        "params": {
            "rule_id": {
                value: null,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling-settings.module.js");
                }
            },
        ],
        "onEnter": [
            'TeamScheduleService',
            'userPermissions',
            'userServices',
            '$state',
            'hUser',
            'useABSSettingsFactory',
            async (
                TeamScheduleService,
                userPermissions,
                userServices,
                $state,
                hUser,
                useABSSettingsFactory,
            ) => {
            const absSettingsFactory = useABSSettingsFactory();
            const activeBrandId = hUser.getActiveBrandIdWithAccess();
            const [activeBrandSettings] = await GatewayTeamLiveAPI.getBrandsSettingsV3(hUser.getUserContext().brand_id, {brand_ids: [activeBrandId]});

            try {
                const [
                    settings,
                    isBusinessForecastingSettingsVisible,
                ] = await Promise.all([
                    ActivityBasedSchedulingAPI.getAbsBusinessSettings(activeBrandId),
                    absSettingsFactory.isBusinessForecastingSettingsVisible(
                        hUser.getEntryMode().brand_id,
                        activeBrandId,
                        activeBrandSettings.type,
                        true,
                    ),
                ]);

                if (
                    !settings?.bulk_rule_apply_enabled ||
                    !isBusinessForecastingSettingsVisible
                ) {
                    $state.go("appLayout.schedule.settings", { activeTab: 'GENERAL' });
                }
            } catch (error) {
                $state.go("appLayout.schedule.settings", { activeTab: 'GENERAL' });
            }
        }],
    },
    "/forecast-templates-rule/:rule_id?duplicate_id&step": {
        "name": "appLayout.harriSH.access-portal.settings.forecast-settings-rule",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'manageAbsForecastRuleContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: [
                'abs-settings',
            ],
        },
        "params": {
            "rule_id": {
                value: null,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling-settings.module.js");
                }
            },
        ],
        "onEnter": [
            'hUser',
            'userPermissions',
            'userServices',
            '$state',
            '$stateParams',
            'hmapService',
            'useABSSettingsFactory',
            async (
                hUser,
                userPermissions,
                userServices,
                $state,
                $stateParams,
                hmapService,
                useABSSettingsFactory,
            ) => {
                const absSettingsFactory = useABSSettingsFactory();

                const activeBrandId = hmapService.getActiveBrand($stateParams.hmapPath);
                const hmapBrandInfo = await hmapService.loadBrandDetails(activeBrandId);
                const activeBrandType = hmapBrandInfo?.type;

                try {
                const [
                    settings,
                    isBusinessForecastingSettingsTabValid,
                ] = await Promise.all([
                    ActivityBasedSchedulingAPI.getAbsBusinessSettings(activeBrandId),
                    absSettingsFactory.isBusinessForecastingSettingsVisible(
                        hUser.getEntryMode().brand_id,
                        activeBrandId,
                        activeBrandType,
                        true,
                    )
                ]);

                if (
                    !settings?.bulk_rule_apply_enabled ||
                    !isBusinessForecastingSettingsTabValid
                ) {
                    $state.go("appLayout.harriSH.access-portal.settings.main", {activeTab: 'GENERAL'});
                }
            } catch (error) {
                $state.go("appLayout.harriSH.access-portal.settings.main", {activeTab: 'GENERAL'});
            }
        }],
    },
};